export enum TableShape {
    Rectangular = 'Rectangular',
    Round = 'Round'
}
